import { render, staticRenderFns } from "./LiveBroadcasts.vue?vue&type=template&id=44b30862&scoped=true&lang=pug&"
import script from "./LiveBroadcasts.vue?vue&type=script&lang=ts&"
export * from "./LiveBroadcasts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b30862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arc-one/_www/millsta-ready/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b30862')) {
      api.createRecord('44b30862', component.options)
    } else {
      api.reload('44b30862', component.options)
    }
    module.hot.accept("./LiveBroadcasts.vue?vue&type=template&id=44b30862&scoped=true&lang=pug&", function () {
      api.rerender('44b30862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/templates/LiveBroadcasts.vue"
export default component.exports